
export default {

    /**
     * Nombre del componente
     */
    name: 'YuriLabel',
    /**
     * @override
     */
    data() {
        return {
            offsetWidth: 0,
            scrollWidth: 0,
            toolTipId: Math.random()
                .toString(36)
                .substring(7)
        };
    },

    /**
     * Propiedades de entrada
     * label: Texto que se mostrará en el label
     * text: texto a mostrar
     * literal: diccionario al que se debe acceder para buscar el literal
     * isDate: indica que text es una fecha
     */
    props : {
        label : {
            type     : String,
            required : true
        },
        text : {
            type     : String,
            required : false
        },
        literal : {
            type     : String,
            required : false
        },
        isDate : {
            type     : Boolean,
            required : false
        },
        isDateFull : {
            type     : Boolean,
            required : false
        },
        isMonth : {
            type     : Boolean,
            required : false
        },
        isCurrency : {
            type     : Boolean,
            required : false
        },
        isLongCurrency : {
            type     : Boolean,
            required : false
        },
        isDecimal : {
            type     : Boolean,
            required : false
        },
        aditionalClass : {
            type     : String,
            required : false,
            default  : ''
        },
        hasLabelToolTip: {
            type     : Boolean,
            required : false,
            default  : false
        },
        labelToolTip: {
            type     : String,
            required : false
        }
    },
    computed: {
        isEllipsisActive() {
            if (this.offsetWidth) {
                return (this.offsetWidth < this.scrollWidth);
            } else {
                return false;
            }
        }
    },
    methods: {
        outputsize() {
            this.offsetWidth = this.$el.getElementsByClassName('ellipsis')[0].offsetWidth;
            this.scrollWidth = this.$el.getElementsByClassName('ellipsis')[0].scrollWidth;
        }
    },
    /**
     * @override
     */
    beforeMount() {
        if (this.hasLabelToolTip && this.labelToolTip) {
            this.toolTipId = this.labelToolTip.trim().replace(/ /g, '_');
            if (!this.toolTipId) {
                this.toolTipId = Math.random()
                    .toString(36)
                    .substring(7);
            }
        }
    },
    mounted() {
        const elipsis = this.$el.getElementsByClassName('ellipsis');
        if (elipsis.length) {
            this.offsetWidth = this.$el.getElementsByClassName('ellipsis')[0].offsetWidth;
            this.scrollWidth = this.$el.getElementsByClassName('ellipsis')[0].scrollWidth;
            new ResizeObserver(this.outputsize).observe(this.$el.getElementsByClassName('ellipsis')[0]);
            this.outputsize();
        }
    }
};
